import Vue from "vue";
import Router from "vue-router";
import checkSign from "@/plugins/checkSign";
// 模板分类
import layout from "@/pages/layout";
// 资源展示
import material from "@/components/Admin/materials";
import videos from "@/components/User/resources/videos";

// >admin
// 比赛
import adminActivity from "@/pages/admin/compete/activities";
import schoolCompeteActivities from "@/pages/school/compete/activities/index.js";
// 通知
import adminLogin from "@/pages/admin/auth";
import org from "@/pages/admin/org";
import user from "@/pages/admin/user";
import adminNotifiction from "@/pages/admin/notifiction";

// 教改项目
import researchActivities from "@/pages/admin/research/activities";
import researchCatalogs from "@/pages/admin/research/catalogs";
import researchFunds from "@/pages/admin/research/funds";
import researchProjects from "@/pages/admin/research/projects";
// 培训
import adminTrainActivity from "@/pages/admin/train/activity";
import adminTrainCourse from "@/pages/admin/train/course";
// >user
import userResearchActivities from "@/components/User/research/activities";
import userResearchProjects from "@/components/User/research/projects";
import userResearchFunds from "@/pages/user/research/funds";
import userResearchReceipt from "@/pages/user/research/receipts";
import userMeetingBooking from "@/pages/user/meeting/booking";
import userMeetingAppointment from "@/pages/user/meeting/appointment";
// > expert
import expertCenter from "@/pages/expert/center";
import expertCompete from "@/pages/expert/compete";
import expertResearch from "@/pages/expert/research";
import expertTrain from "@/pages/expert/train";
// > school
import schoolRearch from "@/components/schools/research/projects";
// > mobile
import mobileAuth from "@/pages/mobile/auth";
import mobileProject from "@/pages/mobile/project";
// germany
import germanyHome from "@/pages/germany/home";

import orgs from "@/pages/admin/stat/orgs";

// 教学研究会主页
const ResearchSociety = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/ResearchSociety.vue")),
    "ResearchSociety"
  );
const mediasDetail = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/mediasDetail.vue")),
    "mediasDetail"
  );
// 培训平台首页
const TrainHomePage = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/TrainHomePage.vue")),
    "TrainHomePage"
  );
// 登录注册页面及重置密码
const SignIn = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/SignIn.vue")),
    "SignIn"
  );
const SignUp = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/SignUp.vue")),
    "SignUp"
  );
const ResetInfo = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/ResetInfo.vue")),
    "ResetInfo"
  );

// 学校管理员用户界面
const School = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/schools/School.vue")),
    "School"
  );
const SchoolSign = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/schools/SignUp.vue")),
    "SchoolSign"
  );
const SchoolCompetes = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/schools/compete/Competes.vue")),
    "SchoolCompetes"
  );
const SchoolTrains = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/schools/train/Trains.vue")),
    "SchoolTrains"
  );
const SchoolActivities = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/schools/compete/Activities.vue")),
    "SchoolActivities"
  );
const SchoolProjects = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/schools/compete/Projects.vue")),
    "SchoolProjects"
  );
const Entries = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/schools/compete/Entries.vue")),
    "Entries"
  );
const TrainEntries = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/schools/train/TrainEntries.vue")),
    "TrainEntries"
  );

// 个人中心功能页面
const UserCompete = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Center/UserCompete.vue")),
    "UserCompete"
  );
const UserCompeteDetail = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Center/UserCompeteDetail.vue")),
    "UserCompeteDetail"
  );

// 培训平台主要功能页面
const UserCenter = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/UserCenter.vue")),
    "UserCenter"
  );
const UserTrain = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/UserTrain.vue")),
    "UserTrain"
  );
const UserApplyList = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/UserApplyList.vue")),
    "UserApplyList"
  );
const UserApplyForm = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/UserApplyForm.vue")),
    "UserApplyForm"
  );
const UserCourse = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/UserCourse.vue")),
    "UserCourse"
  );
const UserRegister = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/UserRegister.vue")),
    "UserRegister"
  );
const UserWork = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/UserWork.vue")),
    "UserWork"
  );
const UserJournal = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/UserJournal.vue")),
    "UserJournal"
  );
const UserMessage = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/UserMessage.vue")),
    "UserMessage"
  );
const UserNotification = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Train/Notification.vue")),
    "UserNotification"
  );

// 比赛平台主要功能页面
const Compete = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Compete/Competes.vue")),
    "Compete"
  );
const CompeteDetail = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Compete/CompeteDetail.vue")),
    "CompeteDetail"
  );
const CompeteApply = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Compete/CompeteApply.vue")),
    "CompeteApply"
  );
const CheckApply = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/User/Compete/CheckApply.vue")),
    "CheckApply"
  );

// 培训管理后台路由
const TrainBackPlatform = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/TrainBackPlatform.vue")),
    "TrainBackPlatform"
  );
const Templates = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Template/Templates.vue")),
    "Templates"
  );
const TemplateDetail = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Template/TemplateDetail.vue")),
    "TemplateDetail"
  );
const TrainSetting = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Train/TrainIndex.vue")),
    "TrainSetting"
  );
const TrainCreate = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Train/TrainCreate.vue")),
    "TrainCreate"
  );
const TrainCourse = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Train/TrainCourse.vue")),
    "TrainCourse"
  );
const TrainCourseDetail = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Train/TrainCourseDetail.vue")),
    "TrainCourseDetail"
  );
const TrainTask = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Train/TrainTask.vue")),
    "TrainTask"
  );
const TrainLog = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Train/TrainLog.vue")),
    "TrainLog"
  );
const TrainTaskDetail = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Train/TrainTaskDetail.vue")),
    "TrainTaskDetail"
  );
const TrainPatch = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Train/TrainPatch.vue")),
    "TrainPatch"
  );
const ApplyUser = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Apply/ApplyUser.vue")),
    "ApplyUser"
  );
const UserAssign = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/User/UserAssign.vue")),
    "UserAssign"
  );
const UserSetting = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/User/UserSetting.vue")),
    "UserSetting"
  );
const MediaSetting = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Media/MediaSetting.vue")),
    "MediaSetting"
  );
const MediaCreate = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Media/MediaCreate.vue")),
    "MediaCreate"
  );
const HelpCenter = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/HelpCenter.vue")),
    "HelpCenter"
  );
const AccountSetting = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/Train/Account/AccountSetting.vue")),
    "AccountSetting"
  );

// 培训室预约管理
const MeetingRooms = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/meeting/MeetingRooms.vue")),
    "MeetingRooms"
  );
const MeetingAgendas = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/meeting/MeetingAgendas.vue")),
    "MeetingAgendas"
  );
const Appointments = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/meeting/Appointments.vue")),
    "Appointments"
  );
const Reserves = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/meeting/Reserves.vue")),
    "Reserves"
  );
const MeetingHome = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/meeting/MeetingHome.vue")),
    "MeetingHome"
  );
const MeetingManagement = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/meeting/MeetingManagement.vue")),
    "MeetingManagement"
  );

// 培训室预约
// const MeetingBooking = r => require.ensure([], () => r(require('@/components/User/meeting/MeetingBooking.vue')), 'MeetingBooking');
// const Appointment = r => require.ensure([], () => r(require('@/components/User/meeting/Appointments.vue')), 'Appointment');
// const Reserve = r => require.ensure([], () => r(require('@/components/User/meeting/Reserves.vue')), 'Reserve');

// 管理比赛
const Activities = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/compete/Activities.vue")),
    "Activities"
  );
const Projects = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/compete/Projects.vue")),
    "Projects"
  );
const Marks = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/compete/Marks.vue")),
    "Marks"
  );

// 管理员端
const RoleAssign = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Admin/RoleAssign.vue")),
    "RoleAssign"
  );

// 签到页
const Register = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Register/Register.vue")),
    "Register"
  );
const UserRegisterMobile = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Register/UserRegister.vue")),
    "UserRegister"
  );
const UserRegisterState = (r) =>
  require.ensure(
    [],
    () => r(require("@/components/Register/UserRegisterState.vue")),
    "UserRegisterState"
  );
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    ...orgs,
    ...layout,
    ...adminLogin,
    ...adminActivity,
    ...user,
    ...org,
    ...adminNotifiction,
    ...videos,
    ...material,
    ...researchActivities,
    ...researchCatalogs,
    ...researchFunds,
    ...researchProjects,
    ...adminTrainActivity,
    ...adminTrainCourse,
    ...userResearchActivities,
    ...userResearchProjects,
    ...userResearchFunds,
    ...userResearchReceipt,
    ...userMeetingBooking,
    ...userMeetingAppointment,
    ...expertCenter,
    ...expertCompete,
    ...expertResearch,
    ...expertTrain,
    ...schoolRearch,
    ...mobileProject,
    ...mobileAuth,
    // germany
    ...germanyHome,
    ...schoolCompeteActivities,
    {
      path: "/",
      name: "ResearchSociety",
      component: ResearchSociety,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/register/:course_id",
      name: "Register",
      component: Register,
      meta: {
        title: "上海高职高专师资公共培训基地",
      },
    },
    {
      path: "/register_mobile_sign",
      name: "UserRegisterMobile",
      component: UserRegisterMobile,
      meta: {
        title: "上海高职高专师资公共培训基地",
      },
    },
    {
      path: "/register_mobile/:schedule_id",
      name: "UserRegisterState",
      component: UserRegisterState,
      beforeEnter: (to, from, next) => {
        checkSign.checkUser(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
      },
    },
    {
      path: "/reports/:report_id",
      name: "mediasDetail",
      component: mediasDetail,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/train",
      name: "TrainHomePage",
      component: TrainHomePage,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/signIn",
      name: "SignIn",
      component: SignIn,
      meta: {
        title: "上海高职高专师资公共培训基地",
      },
    },
    {
      path: "/signUp",
      name: "SignUp",
      component: SignUp,
      meta: {
        title: "上海高职高专师资公共培训基地",
      },
    },
    {
      path: "/reset",
      name: "ResetInfo",
      component: ResetInfo,
      meta: {
        title: "上海高职高专师资公共培训基地",
      },
    },
    {
      path: "/notification",
      name: "UserNotification",
      component: UserNotification,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/user",
      name: "UserCenter",
      component: UserCenter,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/user/trains",
      name: "UserTrain",
      component: UserTrain,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/user/competes",
      name: "UserCompete",
      component: UserCompete,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/user/competes/:id",
      name: "UserCompeteDetail",
      component: UserCompeteDetail,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/userApply",
      name: "UserApplyForm",
      component: UserApplyForm,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/myTrains/:id/userApplyList",
      name: "UserApplyList",
      component: UserApplyList,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/user/trains/:train_id/courses",
      name: "UserCourse",
      component: UserCourse,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/courses/:register_id/register",
      name: "UserRegister",
      component: UserRegister,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/user/trains/:train_id/works",
      name: "UserWork",
      component: UserWork,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/user/trains/:train_id/logs",
      name: "UserJournal",
      component: UserJournal,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/message",
      name: "UserMessage",
      component: UserMessage,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/competes",
      name: "Compete",
      component: Compete,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/competes/:competeId",
      name: "CompeteDetail",
      component: CompeteDetail,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/competes/:competeId/apply",
      name: "CompeteApply",
      component: CompeteApply,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/competes/:competeId/check-apply/:checkId",
      name: "CheckApply",
      component: CheckApply,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "compete",
      },
    },
    {
      path: "/school",
      name: "School",
      component: School,
      beforeEnter: (to, from, next) => {
        checkSign.checkSchool(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "school",
      },
    },
    {
      path: "/school/competes",
      name: "SchoolCompetes",
      component: SchoolCompetes,
      beforeEnter: (to, from, next) => {
        checkSign.checkSchool(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "school",
      },
    },
    {
      path: "/school/trains",
      name: "SchoolTrains",
      component: SchoolTrains,
      beforeEnter: (to, from, next) => {
        checkSign.checkSchool(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "school",
      },
    },
    {
      path: "/school/sign",
      name: "SchoolSign",
      component: SchoolSign,
      beforeEnter: (to, from, next) => {
        checkSign.checkSchool(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
      },
    },
    {
      path: "/admin",
      name: "TrainBackPlatform",
      component: TrainBackPlatform,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/Templates",
      name: "Templates",
      component: Templates,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/Templates/:id",
      name: "TemplateDetail",
      component: TemplateDetail,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/trains",
      name: "TrainSetting",
      component: TrainSetting,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/train/create",
      name: "TrainCreate",
      component: TrainCreate,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/trains/:trainId/courses",
      name: "TrainCourse",
      component: TrainCourse,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/trains/:trainId/courses/:courseId",
      name: "TrainCourseDetail",
      component: TrainCourseDetail,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/trains/:trainId/tasks",
      name: "TrainTask",
      component: TrainTask,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/trains/:trainId/logs",
      name: "TrainLog",
      component: TrainLog,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/trains/:trainId/tasks/:taskId",
      name: "TrainTaskDetail",
      component: TrainTaskDetail,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/train/:id",
      name: "TrainPatch",
      component: TrainPatch,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/train/:train_id/apply",
      name: "ApplyUser",
      component: ApplyUser,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/userAssign",
      name: "UserAssign",
      component: UserAssign,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/users",
      name: "UserSetting",
      component: UserSetting,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/medias",
      name: "MediaSetting",
      component: MediaSetting,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/medias/:id",
      name: "MediaCreate",
      component: MediaCreate,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/medias/create",
      name: "admin/medias/create",
      component: MediaCreate,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/helpCenter",
      name: "HelpCenter",
      component: HelpCenter,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/accountSetting",
      name: "AccountSetting",
      component: AccountSetting,
      beforeEnter: (to, from, next) => {
        checkSign.checkAdmin(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/school/train/entries",
      name: "TrainEntries",
      component: TrainEntries,
      beforeEnter: (to, from, next) => {
        checkSign.checkSchool(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "school",
      },
    },
    // {
    //   path: '/meeting/reserve',
    //   name: 'MeetingBooking',
    //   component: MeetingBooking,
    //   meta: {
    //     title: '上海高职高专师资公共培训基地',
    //     layout: 'compete',
    //   },
    // },
    // {
    //   path: '/meeting/appointments',
    //   name: 'Appointment',
    //   component: Appointment,
    //   meta: {
    //     title: '上海高职高专师资公共培训基地',
    //     layout: 'compete',
    //   },
    // },
    // {
    //   path: '/meeting/appointments/:id',
    //   name: 'Reserve',
    //   component: Reserve,
    //   meta: {
    //     title: '上海高职高专师资公共培训基地',
    //     layout: 'compete',
    //   },
    // },
    {
      path: "/admin/meeting/rooms",
      name: "MeetingRooms",
      component: MeetingRooms,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/meeting/agendas",
      name: "MeetingAgendas",
      component: MeetingAgendas,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/meeting/appointments",
      name: "Appointments",
      component: Appointments,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/meeting/appointments/:id",
      name: "Reserves",
      component: Reserves,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/meeting",
      name: "MeetingHome",
      component: MeetingHome,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/meeting/reserve",
      name: "MeetingManagement",
      component: MeetingManagement,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/compete/activities",
      name: "Activities",
      component: Activities,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/compete/activities/:id",
      name: "Projects",
      component: Projects,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/compete/projects/:id",
      name: "Marks",
      component: Marks,
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "admin",
      },
    },
    {
      path: "/admin/experts",
      name: "RoleAssign",
      component: RoleAssign,
      meta: {
        title: "专家管理",
        layout: "admin",
      },
    },
    {
      path: "/school/compete/activities",
      name: "SchoolActivities",
      component: SchoolActivities,
      beforeEnter: (to, from, next) => {
        checkSign.checkSchool(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "school",
      },
    },
    {
      path: "/school/compete/activities/:id",
      name: "SchoolProjects",
      component: SchoolProjects,
      beforeEnter: (to, from, next) => {
        checkSign.checkSchool(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "school",
      },
    },
    {
      path: "/school/compete/entries",
      name: "Entries",
      component: Entries,
      beforeEnter: (to, from, next) => {
        checkSign.checkSchool(to, from, next);
      },
      meta: {
        title: "上海高职高专师资公共培训基地",
        layout: "school",
      },
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js